(function() {
  "use strict";
  function initFancybox() {
    if (!document.body.classList.contains("template-product")) return;
    if (typeof Fancybox === "undefined") {
      return;
    }
    const productImages = document.querySelectorAll(".product__media img");
    productImages.forEach((img, index) => {
      const fancyboxData = img.parentElement.querySelector(".fancybox-data");
      if (fancyboxData) {
        try {
          const data = JSON.parse(fancyboxData.textContent);
          img.setAttribute("data-fancybox", data.fancybox);
          img.setAttribute("data-src", data.src);
          img.setAttribute("data-caption", data.caption);
          img.style.cursor = "pointer";
        } catch (e) {
          console.warn("Errore nel parsing dei dati Fancybox:", e);
        }
      }
    });
    Fancybox.bind('[data-fancybox="product-gallery"]', {
      // Configurazione base
      Toolbar: {
        display: {
          left: ["infobar"],
          middle: ["zoomIn", "zoomOut", "toggle1to1", "rotateCCW", "rotateCW", "flipX", "flipY"],
          right: ["slideshow", "thumbs", "close"]
        }
      },
      // Configurazione thumbnails
      Thumbs: {
        autoStart: true,
        hideOnClose: true
      },
      // Configurazione slideshow
      Slideshow: {
        autoStart: false,
        speed: 3e3
      },
      // Configurazione zoom
      zoom: {
        wheel: true,
        touch: true,
        max: 3
      },
      // Configurazione animazioni
      animationEffect: "fade",
      transitionEffect: "slide",
      transitionDuration: 300
    });
  }
  function initProductSticky() {
    const productInfoContainer = document.querySelector(".product__info-container");
    const productMediaWrapper = document.querySelector(".product__media-wrapper");
    if (!productInfoContainer || !productMediaWrapper) return;
    function updateStickyPosition() {
      const mediaRect = productMediaWrapper.getBoundingClientRect();
      const mediaBottom = mediaRect.bottom;
      const viewportHeight = window.innerHeight;
      const stickyTop = 20;
      if (mediaBottom < viewportHeight) {
        productInfoContainer.style.position = "static";
        productInfoContainer.style.top = "auto";
        productInfoContainer.style.maxHeight = "none";
      } else {
        productInfoContainer.style.position = "sticky";
        productInfoContainer.style.top = `${stickyTop}px`;
        productInfoContainer.style.maxHeight = `calc(100vh - ${stickyTop * 2}px)`;
      }
    }
    updateStickyPosition();
    window.addEventListener("scroll", debounce(updateStickyPosition, 10));
    window.addEventListener("resize", debounce(updateStickyPosition, 100));
  }
  document.addEventListener("DOMContentLoaded", function() {
    if (document.body.classList.contains("template-product")) {
      initProductSticky();
    }
    initFancybox();
  });
  function debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      // Non intercettare Iubenda / preferenze cookie
      if (
        anchor.classList.contains("iubenda-cs-preferences-link") ||
        anchor.classList.contains("iubenda-advertising-preferences-link") ||
        anchor.classList.contains("iubenda-cs-uspr-link")
      ) {
        return;
      }
      const href = anchor.getAttribute("href");
      if (!href || href === "#" || href === "#/") return;

      anchor.addEventListener("click", function (e) {
        const target = document.querySelector(this.getAttribute("href"));
        if (!target) return;
        e.preventDefault();
        target.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });
      });
    });
  }
  function initLazyLoading() {
    const images = document.querySelectorAll("img[data-src]");
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.src = img.dataset.src;
          img.classList.remove("lazy");
          observer.unobserve(img);
        }
      });
    });
    images.forEach((img) => imageObserver.observe(img));
  }
  function initVerticalProductGallery() {
    const gallery = document.querySelector(".product-gallery-vertical");
    if (!gallery) return;
    const mediaItems = gallery.querySelectorAll(".product-media-item");
    mediaItems.forEach((item, index) => {
      const img = item.querySelector("img");
      if (img) {
        item.style.cursor = "pointer";
      }
    });
    let currentIndex = 0;
    let ticking = false;
    function updateActiveImage() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const galleryRect = gallery.getBoundingClientRect();
      galleryRect.top + scrollTop;
      let closestIndex = 0;
      let minDistance = Infinity;
      mediaItems.forEach((item, index) => {
        const itemRect = item.getBoundingClientRect();
        const itemTop = itemRect.top + scrollTop;
        const itemCenter = itemTop + itemRect.height / 2;
        const viewportCenter = scrollTop + window.innerHeight / 2;
        const distance = Math.abs(itemCenter - viewportCenter);
        if (distance < minDistance) {
          minDistance = distance;
          closestIndex = index;
        }
      });
      if (closestIndex !== currentIndex) {
        mediaItems.forEach((item) => item.classList.remove("active"));
        if (mediaItems[closestIndex]) {
          mediaItems[closestIndex].classList.add("active");
          currentIndex = closestIndex;
        }
      }
      ticking = false;
    }
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(updateActiveImage);
        ticking = true;
      }
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    if (mediaItems[0]) {
      mediaItems[0].classList.add("active");
    }
    return function() {
      window.removeEventListener("scroll", onScroll);
    };
  }
  function fixProductDescriptionPosition() {
    if (document.body.classList.contains("template-product")) {
      const description = document.querySelector(".product__description");
      const buyButtons = document.querySelector(".product-form__buttons");
      if (description && buyButtons) {
        buyButtons.parentNode.insertBefore(description, buyButtons);
      }
    }
  }
  function initCustomSwiper() {
    if (typeof Swiper === "undefined") {
      return;
    }
    const swiperContainers = document.querySelectorAll(".custom-products-swiper");
    swiperContainers.forEach((container) => {
      container.dataset.sectionId;
      const slides = container.querySelectorAll(".swiper-slide");
      const customSwiper = container.closest(".custom-swiper");
      const nextBtn = customSwiper == null ? void 0 : customSwiper.querySelector(".swiper-button-next");
      const prevBtn = customSwiper == null ? void 0 : customSwiper.querySelector(".swiper-button-prev");
      if (!nextBtn || !prevBtn) {
        return;
      }
      const swiper = new Swiper(container, {
        // Impostazioni base
        loop: slides.length > 4,
        // Loop solo se ci sono più di 4 slide
        autoplay: {
          delay: 3e3,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        },
        speed: 600,
        // Navigazione
        navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn
        },
        // Responsive breakpoints - 4 prodotti desktop
        breakpoints: {
          320: {
            slidesPerView: 2,
            spaceBetween: 10,
            centeredSlides: false
          },
          576: {
            slidesPerView: 2,
            spaceBetween: 15,
            centeredSlides: false
          },
          768: {
            slidesPerView: 3,
            spaceBetween: 20,
            centeredSlides: false
          },
          992: {
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false
          },
          1200: {
            slidesPerView: 4,
            spaceBetween: 20,
            centeredSlides: false
          }
        },
        // Eventi personalizzati
        on: {
          init: function() {
          },
          breakpoint: function() {
          }
        }
      });
      container.addEventListener("mouseenter", () => {
        swiper.autoplay.stop();
      });
      container.addEventListener("mouseleave", () => {
        swiper.autoplay.start();
      });
    });
  }
  function initHeroBannerSwiper() {
    if (typeof Swiper === "undefined") {
      return;
    }
    const heroBanners = document.querySelectorAll(".hero-banner-swiper");
    heroBanners.forEach((container) => {
      if (container.dataset.swiperInitialized === "true") {
        return;
      }
      const slides = container.querySelectorAll(".swiper-slide");
      const autoplayEnabled = container.dataset.autoplay === "true" && slides.length > 1;
      const autoplayDelay = Number(container.dataset.autoplayDelay || 5000);
      const transitionSpeed = Number(container.dataset.transitionSpeed || 700);
      const showArrows = container.dataset.showArrows === "true";
      const showDots = container.dataset.showDots === "true";
      const nextBtn = container.querySelector(".swiper-button-next");
      const prevBtn = container.querySelector(".swiper-button-prev");
      const paginationEl = container.querySelector(".swiper-pagination");

      const options = {
        loop: slides.length > 1,
        speed: transitionSpeed,
        grabCursor: true,
        effect: "fade",
        fadeEffect: {
          crossFade: true
        }
      };

      if (autoplayEnabled) {
        options.autoplay = {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        };
      }

      if (showArrows && nextBtn && prevBtn) {
        options.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn
        };
      }

      if (showDots && paginationEl) {
        options.pagination = {
          el: paginationEl,
          clickable: true
        };
      }

      new Swiper(container, {
        ...options,
        on: {
          slideChangeTransitionStart(swiper) {
            const slide = swiper.slides[swiper.activeIndex];
            container.dispatchEvent(
              new CustomEvent("semenzato:heroSlideChange", {
                detail: { slide }
              })
            );
          }
        }
      });
      container.dataset.swiperInitialized = "true";
    });
  }
  function initFeaturedCollectionSwiper() {
    if (typeof Swiper === "undefined") {
      return;
    }
    const featuredSwipers = document.querySelectorAll(".featured-products-swiper");
    featuredSwipers.forEach((container) => {
      if (container.dataset.swiperInitialized === "true") {
        return;
      }
      const slides = container.querySelectorAll(".swiper-slide");
      if (!slides.length) {
        return;
      }
      const autoplayDelay = Number(container.dataset.autoplayDelay || 2500);
      const transitionSpeed = Number(container.dataset.transitionSpeed || 320);
      const wrapper = container.closest(".featured-collection") || container.parentElement;
      const nextBtn = wrapper && wrapper.querySelector(".swiper-button-next");
      const prevBtn = wrapper && wrapper.querySelector(".swiper-button-prev");
      const swiperOptions = {
        loop: slides.length > 1,
        autoplay: slides.length > 1 ? {
          delay: autoplayDelay,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        } : false,
        speed: transitionSpeed,
        grabCursor: true,
        breakpoints: {
          320: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          480: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          640: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          768: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          992: {
            slidesPerView: 1,
            spaceBetween: 20,
            centeredSlides: false
          },
          1200: {
            slidesPerView: 1,
            centeredSlides: false
          }
        }
      };
      if (nextBtn && prevBtn) {
        swiperOptions.navigation = {
          nextEl: nextBtn,
          prevEl: prevBtn
        };
      }
      const swiper = new Swiper(container, swiperOptions);
      container.addEventListener("mouseenter", () => {
        if (swiper.autoplay && swiper.autoplay.running) {
          swiper.autoplay.stop();
        }
      });
      container.addEventListener("mouseleave", () => {
        if (swiper.autoplay) {
          swiper.autoplay.start();
        }
      });
      container.dataset.swiperInitialized = "true";
    });
  }
  document.addEventListener("DOMContentLoaded", () => {
    initSmoothScroll();
    initLazyLoading();
    initVerticalProductGallery();
    fixProductDescriptionPosition();
    const waitForSwiper = () => {
      if (typeof Swiper !== "undefined") {
        initCustomSwiper();
        initFeaturedCollectionSwiper();
        initHeroBannerSwiper();
      } else {
        setTimeout(waitForSwiper, 100);
      }
    };
    waitForSwiper();
  });
})();
